<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'

const props = defineProps<{
  message: string // HTML-Content als String
  thankYouMessage?: string | null // Optionaler Dankestext
}>()

const displayedMessage = ref('')
const isTyping = ref(true)

// Geschwindigkeit des Typewriters (ms pro step)
const TYPE_SPEED = 2
// Anzahl der Zeichen, die pro Step hinzugefügt werden
const CHARS_PER_STEP = 3

// Funktion zum "Tippen" des HTML-Inhalts
const typeWriter = (htmlContent: string) => {
  let i = 0
  let currentHtml = ''
  let inTag = false

  const type = () => {
    if (i < htmlContent.length) {
      // Mehrere Zeichen pro Durchlauf verarbeiten für höhere Geschwindigkeit
      let charsProcessed = 0

      while (i < htmlContent.length && (charsProcessed < CHARS_PER_STEP || inTag)) {
        const char = htmlContent.charAt(i)

        if (char === '<') {
          inTag = true
        }

        currentHtml += char
        i++
        // Zeichen nur zählen wenn wir nicht in einem Tag sind (Tags sollen sofort erscheinen)
        if (!inTag) {
          charsProcessed++
        }

        if (char === '>') {
          inTag = false
        }
      }

      displayedMessage.value = currentHtml

      if (i < htmlContent.length) {
        setTimeout(type, TYPE_SPEED)
      } else {
        isTyping.value = false
      }
    } else {
      isTyping.value = false
    }
  }

  type()
}

onMounted(() => {
  if (props.message) {
    typeWriter(props.message)
  }
})

watch(
  () => props.message,
  (newVal) => {
    if (newVal) {
      displayedMessage.value = ''
      isTyping.value = true
      typeWriter(newVal)
    }
  },
)
</script>

<template>
  <div class="finish-message">
    <div class="hero">
      <div class="hero-body pt-5">
        <div class="container">
          <div class="content is-medium">
            <div class="message-content">
              <div v-if="thankYouMessage" v-html="thankYouMessage"></div>
              <span v-html="displayedMessage"></span>
              <span v-if="isTyping" class="cursor">|</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
@import '../../../assets/main.css';

.cursor {
  display: inline-block;
  width: 2px;
  background-color: var(--primary-color, currentColor);
  animation: blink 1s step-end infinite;
  margin-left: 2px;
  vertical-align: text-bottom;
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
</style>
